import mock from "../mock"

export const searchResult = [
  {
    groupTitle: "Pages",
    searchLimit: 4,
    data: [
      {
        id: 1,
        target: "home",
        title: "Home",
        link: "/",
        icon: "Home"
      },
      {
        id: 2,
        target: "page",
        title: "Liquidity Pool",
        link: "/liquidity/LiquidityPools",
        icon: "Layers"
      },
      {
        id: 3,
        target: "page",
        title: "Factory Config",
        link: "/config/Factory",
        icon: "Layers"
      }
    ]
  }
]

mock.onGet("/api/main-search/data").reply(200, {
  searchResult
})
